import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { FiLogOut } from "react-icons/fi";

import DropdownMenu from "../../components/Dropdown";

import { APP_DOMAINS } from "../../constants";

import Logo from "../../assets/images/st-logo.svg";
import sellerRepay from "../../assets/images/logo-sp.svg";

import { HeaderStWrapper, HeaderDropDownStyleWrapper } from "./style";

import { LogOut } from "../../redux/slices/auth-slice";

const HeaderSt = () => {
  const hostName = window.location.hostname;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const initials = user?.name?.match(/\b\w/g).join('');

  const dropdownMenuTitle = () => {
    return (
      <HeaderDropDownStyleWrapper>
        <div className="title_wrapper">
          <span>{initials?.toUpperCase() || 'YOU'}</span>
          <div className="right_side_text">
            <p>{user?.name || 'Your Name'}</p>
            <p>{user?.email || 'Your Email'}</p>
          </div>
        </div>
      </HeaderDropDownStyleWrapper>
    );
  };

  const menuItems = [
    {
      label: dropdownMenuTitle(),
      key: "0",
    },
    {
      label: (
        <HeaderDropDownStyleWrapper>
          <Button onClick={() => dispatch(LogOut())} icon={<FiLogOut />}>Log Out</Button>
        </HeaderDropDownStyleWrapper>
      ),
      key: "1",
    },
  ];

  return (
    <HeaderStWrapper>
      <img
        className={
          hostName === APP_DOMAINS.sellerTerminal
            ? " seller-terminal"
            : "seller-repay"
        }
        src={hostName === APP_DOMAINS.sellerTerminal ? Logo : sellerRepay}
        alt="no-logo"
      />
      <DropdownMenu
        overlayClassName="header_dropdown_wrapper"
        menuItems={menuItems}
        triggerType="click"
        buttonText={<p>{initials?.toUpperCase() || 'YOU'}</p>}
      />
    </HeaderStWrapper>
  );
};

export default HeaderSt;
